module.exports = __webpack_public_path__ + "static/media/featured-image.5dd7e4a9.webp";